import React, { useState } from 'react'
import { LINKEDIN_SIGNUP_VERIFICATION } from '../../Utils/apis';
import useLogin from '../useLogIn';
import { useNavigate } from 'react-router-dom';

const useUpdatePasswordForLinkedinUsers = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const [a, b, login] = useLogin();


    const setPassword = async (password, candidateId, email) => {
        if (!loading) {
            try {
                setLoading(true)
                const res = await fetch(LINKEDIN_SIGNUP_VERIFICATION, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        userId: candidateId,
                        newPassword : password,
                    }),
                    credentials: 'include',
                });
                await login(email, password);

                if (res.ok) {
                    // return Promise.resolve("Request Sended succesfully");
                    navigate('/jobs', { replace: true });
                    // setSuccess(true);
                }
                else {
                    const err = await res.json();
                    throw new Error(err.error);
                }
            } catch (error) {
                setError(error.message);
                return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }
        }
    }

    return [loading, error, success, setPassword];
}

export default useUpdatePasswordForLinkedinUsers;